import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'plan-management-page',
  templateUrl: './plan-management-page.component.html',
  styleUrls: ['./plan-management-page.component.scss']
})
export class PlanManagementPageComponent implements OnInit {
  data = {
    title: 'ADIEM | NDIS Plan Management - Freedom to choose',
    description:
      'ADIEM Plan Management gives you the freedom to use who you want. Choose any \
      provider and ADIEM will take care of the invoices for you according to your plan.',
    image:
      'https://firebasestorage.googleapis.com/v0/b/adiem-prod.appspot.com/o/images%2Fndis-provider-freedom.jpg?alt=media&token=29e21170-3fb0-471d-9f2e-ffed15c5471a'
  };
  constructor(private title: Title, private meta: Meta) {}

  ngOnInit(): void {
    this.title.setTitle(this.data.title);
    this.meta.addTags([
      { name: 'twitter:card', content: 'summary' },
      { name: 'og:url', content: '/plan-management' },
      { name: 'og:title', content: this.data.title },
      { name: 'og:description', content: this.data.description },
      { name: 'og:image', content: this.data.image }
    ]);
  }
}
